import React from "react";
import { NavLink } from "react-router-dom";
import { websiteLink } from "../../helpers/helpers";
import * as paths from "../../constants/paths";
function Navigation({ active, toggle, logged }) {
  return (
    <>
      <nav className="ease">
        <div id="nav" className={active ? "active" : ""}>
          <ul id="lst">
            {/* <li>
              <NavLink
                to={paths.PUBLIC_SITE_URL}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to={websiteLink("/open-jobs/1")}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Jobs
              </NavLink>
            </li>
            <li>
              <NavLink
                to={paths.events_link}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Events
              </NavLink>
            </li>
            <li>
              <NavLink
                to={paths.resources_link}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Resources
              </NavLink>
            </li>

            <li>
              <NavLink
                to={paths.faqs_link}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                FAQs
              </NavLink>
            </li> */}
            <li>
              <NavLink className="" to={websiteLink("/open-jobs/1")}>
                <img
                  src={paths.SITE_BASE_URL + "/images/nav-job.svg"}
                  alt="doucment image"
                />
                <span>Jobs</span>
              </NavLink>
            </li>
            <li>
              <NavLink className="" to={paths.events_link}>
                <img
                  src={paths.SITE_BASE_URL + "/images/nav-webinar.svg"}
                  alt="doucment image"
                />
                <span>Webinars</span>
              </NavLink>
            </li>
            <li>
              <NavLink className="" to={paths.community_link}>
                <img
                  src={paths.SITE_BASE_URL + "/images/nav-community.svg"}
                  alt="doucment image"
                />
                <span>Community</span>
              </NavLink>
            </li>
            <li>
              <NavLink className="" to={paths.resources_link}>
                <img
                  src={paths.SITE_BASE_URL + "/images/nav-resource.svg"}
                  alt="doucment image"
                />
                <span>Resources</span>
              </NavLink>
            </li>
            <li>
              <NavLink className="" to={paths.faqs_link}>
                <img
                  src={paths.SITE_BASE_URL + "/images/nav-faq.svg"}
                  alt="doucment image"
                />
                <span>FAQs</span>
              </NavLink>
            </li>
            {/* <li className="hide_ipad_new_sm">
              <NavLink className="" to={paths.faqs_link}>
                <img
                  src={paths.SITE_BASE_URL + "/images/nav-faq.svg"}
                  alt="doucment image"
                />
                <span>FAQs</span>
              </NavLink>
            </li> */}
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navigation;
